module.exports = __webpack_public_path__ + "img/hosting_thumbnail.4fa51a35.jpg";